// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__nWOdp","account":"Logo_account__1acuf","dataSharing":"Logo_dataSharing__D5hJD","dataScience":"Logo_dataScience__2H74t","feedback":"Logo_feedback__1gBqZ"};